/**
 * this closure provides some helper functions
 */
const _helpers = (function () {
    function Helpers() {
        const scope = this;

        this.advancedLoaderNodes = {};

        this.validEmail = function () {
            const { name } = this.activeData;

            // const aboutEmailInput = document.querySelector(
            //     `[data-role="users-email"]`
            // );
            const resultsEmailInput = document.querySelector(
                `[data-role="subscription-card-input"]`
            );
            const appError = document.querySelector(`[data-role="form-error"]`);

            if (!resultsEmailInput.value) return true;

            // if (name === 'about-details') {
            //     if (
            //         resultsEmailInput.value.match(/\w+@\w+\.\w+/g) &&
            //         !resultsEmailInput.value.match(/ {1,}/g)
            //     ) {
            //         this.paused(false, false);

            //         resultsEmailInput.classList.remove(
            //             'subject-finder__form-error'
            //         );
            //         resultsEmailInput.classList.remove(
            //             'subject-finder__form-error'
            //         );
            //         appError.textContent = '';
            //     } else {
            //         this.paused(true);

            //         aboutEmailInput.classList.add('subject-finder__form-error');
            //         resultsEmailInput.classList.add(
            //             'subject-finder__form-error'
            //         );
            //         appError.textContent = 'Invalid email address entered.';

            //         resultsEmailInput.disabled = false;
            //     }

            resultsEmailInput.addEventListener('keyup', (e) => {
                const { target } = e;

                if (
                    target.value.match(/\w+@\w+\.\w+/g) &&
                    !resultsEmailInput.value.match(/ {1,}/g)
                ) {
                    this.paused(false, false);

                    // aboutEmailInput.classList.remove(
                    //     'subject-finder__form-error'
                    // );
                    resultsEmailInput.classList.remove(
                        'subject-finder__form-error'
                    );
                    appError.textContent = '';
                } else {
                    this.paused(true);

                    // aboutEmailInput.classList.add(
                    //     'subject-finder__form-error'
                    // );
                    resultsEmailInput.classList.add(
                        'subject-finder__form-error'
                    );
                    appError.textContent = 'Invalid email address entered.';

                    resultsEmailInput.disabled = false;
                }
            });

            if (
                !resultsEmailInput.value.match(/\w+@\w+\.\w+/g) ||
                resultsEmailInput.value.match(/ {1,}/g)
            ) {
                // aboutEmailInput.classList.add('subject-finder__form-error');
                resultsEmailInput.classList.add('subject-finder__form-error');
                appError.textContent = 'Invalid email address entered.';
            }

            // if (
            //     aboutEmailInput.value &&
            //     !aboutEmailInput.value.match(/\w+@\w+\.\w+/g) &&
            //     aboutEmailInput.value.match(/ {1,}/g)
            // ) {
            //     return false;
            // }

            return true;
        };

        /**
         * adds a loading spinner to a selected element
         *
         * @param {HTMLElement}
         * the element to append the spinner to
         *
         * @return {void}
         */
        this.loadSpinner = function (appendTo) {
            if (appendTo) {
                const appendToNode = appendTo;
                const loading = document.createElement('svg');

                if (appendToNode.querySelector(`[data-role="loading-spinner"]`))
                    return;

                appendToNode.innerHTML += `
                    <svg class="load-spinner" viewBox="0 0 24 24" width="36" height="36" data-role="loading-spinner">
                        <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/>
                        <path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="spinner_ajPY"/>
                    </svg>
                `;

                return;
            }

            const activeSpinner = document.querySelector(
                `[data-role="loading-spinner"]`
            );

            if (activeSpinner) activeSpinner.remove();
        };

        this.advancedLoader = function (location, options) {
            const { name } = options;
            const { maxNumberLines, minNumberLines, message } = options;
            const loaderWrapper = document.createElement('div');
            const loaderNode = document.querySelector(
                `[data-loader-name="${name}"]`
            );

            loaderWrapper.dataset.role = 'content-loader';
            loaderWrapper.dataset.loaderName = name;
            loaderWrapper.classList.add('subject-finder__content-load');

            if (!message && maxNumberLines) {
                const lineClasses = ['medium', 'medium-large', 'large', 'half'];
                const randomClass = Math.floor(
                    Math.random() * lineClasses.length
                );
                const min = minNumberLines || 5;
                const paras = [];
                const random = Math.floor(
                    Math.random() * (maxNumberLines - min) + min
                );

                for (let i = 0; i < random; i++) {
                    const para = document.createElement('p');

                    paras.push(para);
                }

                paras[paras.length - 1].classList.add(lineClasses[randomClass]);

                loaderWrapper.append(...paras);
            }

            if (!maxNumberLines && message) {
                const messageBox = document.createElement('div');

                messageBox.innerHTML = `
                    <div class="content-loading-message__inner">
                        <svg class="load-spinner" viewBox="0 0 24 24" width="36" height="36" data-role="loading-spinner">
                            <path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/>
                            <path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z" class="spinner_ajPY"/>
                        </svg>

                        <span>${message}</span>
                    </div>
                `;

                messageBox.classList.add('content-loading-message');

                loaderWrapper.append(messageBox);
            }

            if (location) {
                // scope.advancedLoaderNodes[name] = loaderWrapper;

                location.append(loaderWrapper);

                return;
            }

            if (!location && loaderNode) {
                loaderNode.remove();
            }
        };

        /**
         * sets the checked class to the checkbox
         * input facade
         */
        this.questionActiveState = function () {
            const questionItems = document.querySelectorAll(
                `[data-component="subject-finder"] .subject-finder__page`
            );

            const items = [];

            questionItems.forEach((question) => {
                if (!question.nodeName.match(/input/i)) return;

                // enable checkbox selection with enter
                question.addEventListener('keyup', (e) => {
                    if (
                        e.key.match(/enter/i) &&
                        e.target.type.match(/checkbox|radio/)
                    ) {
                        e.target.click();
                    }
                });

                question.addEventListener('change', (e) => {
                    const { type } = e.target;
                    const { name } = e.target;
                    const relatedQuestions = document.querySelectorAll(
                        `input[name=${name}]`
                    );

                    if (e.target.checked) {
                        if (type === 'radio') {
                            relatedQuestions.forEach((related) => {
                                related.parentElement.classList.remove(
                                    'checked'
                                );
                            });
                        }

                        e.target.parentElement.classList.add('checked');
                    } else {
                        e.target.parentElement.classList.remove('checked');
                    }
                });
            });
        };

        /**
         * click the buttons before and
         * after the navigation progress bar
         * items to scroll back and forth
         *
         * @return {void}
         */
        this.scrollProgressBar = function () {
            const next = document.querySelector(
                `[data-role="progress-scroll-forward"]`
            );
            const prev = document.querySelector(
                `[data-role="progress-scroll-back"]`
            );
            const progressBar = document.querySelector(
                `[data-role="navigation"]`
            );

            next.addEventListener('pointerdown', (e) => {
                progressBar.scrollBy({
                    left: 100,
                    behavior: 'smooth',
                });
            });

            prev.addEventListener('pointerdown', (e) => {
                progressBar.scrollBy({
                    left: -100,
                    behavior: 'smooth',
                });
            });
        };
    }

    return () => {
        return new Helpers();
    };
})();

export default _helpers;
